export class SwitchBarApp {
    private _selectedItems: string[] = [];
    private _items: { id: string; label: string }[] = [];
    private _multiselect: boolean = false;
    private _firstItemWillResetMultiSelect: boolean = false;
    
    public setMultiselect(multiselect: boolean, firstItemWillResetMultiSelect: boolean = false): this {
        this._multiselect = multiselect;
        this._firstItemWillResetMultiSelect = firstItemWillResetMultiSelect;
        return this;
    }

    public setItems(items: { id: string; label: string }[]): this {
        this._items = items;
        return this;
    }

    public getItems(): { id: string; label: string }[] {
        return this._items;
    }

    public selectItems(ids: string[]): this {
        this._selectedItems = ids;
        return this;
    }
    
    public selectItem(id: string): this {
        if (this._multiselect) {
            let idIsFirst = this._items[0].id === id;
            if (this._firstItemWillResetMultiSelect) {
                if (idIsFirst) {
                    this._selectedItems = [id];
                    return this;
                } else {
                    // remove first item
                    this._selectedItems = this._selectedItems.filter(i => i !== this._items[0].id);
                }
            }
            // toggle selection
            if (this._selectedItems.includes(id)) {
                this._selectedItems = this._selectedItems.filter(i => i !== id);
            } else {
                this._selectedItems.push(id);
            }
            
            // select first item when no items selected
            if (this._selectedItems.length === 0 && this._firstItemWillResetMultiSelect) {
                this._selectedItems = [this._items[0].id];
            }
        } else {
            this._selectedItems = [id];
        }
        return this;
    }

    public isItemSelected(id: string): boolean {
        return this._selectedItems.includes(id);
    }

    public getSelectedItems(): string[] {
        return this._selectedItems;
    }
}
